export function getSSDIQualified({ expect_to_be_out_of_work_at_least_a_year, receiving_medical_treatment_for_disability, worked_5_of_last_10_years, has_attorney, age }) {
  const outOfWorkAtLeastAYear = expect_to_be_out_of_work_at_least_a_year === 'yes'
  const receivingMedicalTreatmentForDisability = receiving_medical_treatment_for_disability === 'yes'
  const worked5OutOfTheLast10 = worked_5_of_last_10_years === 'yes'
  const hasAttorney = has_attorney === 'no'
  const ageQualified = age >= 18 && age <= 65

  return outOfWorkAtLeastAYear && receivingMedicalTreatmentForDisability && worked5OutOfTheLast10 && hasAttorney && ageQualified
}